import styled, { css } from 'styled-components';

import alert from '../../../assets/alert.svg';
import colors from '../../../styles/colors';

interface LabelProps {
  isRequired?: boolean;
  isTextOnly?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  input {
    width: 100%;
    border-radius: 5px;
    border: 1px solid #e6e6e6;
    background: transparent;
    height: 50px;
    padding: 0 15px;
    transition: border 0.3s;
    &::placeholder {
      color: ${colors.gray};
    }
    &:focus {
      border: solid 1px ${colors.darkgray};
    }
    &:disabled {
      background: #f2f2f2;
    }
  }
  span {
    color: #c11e1e;
    margin: 5px 0;
  }
  span:before {
    content: url(${alert});
    padding: 0 10px 0 0;
    vertical-align: -10%;
  }
`;

export const Optional = styled.small`
  color: #4d4d4d;
  font-size: 14px;
`;

export const Label = styled.label<LabelProps>`
  font-weight: normal;
  ${(props) =>
    props.isRequired &&
    css`
      font-weight: bold;
    `}

  ${(props) =>
    props.isTextOnly &&
    css`
      font-size: 18px;
      /* font-weight: bold; */
    `}
`;

export const Box = styled.div<LabelProps>`
  margin: 10px 0 5px 0;
  ${(props) =>
    props.isTextOnly &&
    css`
      margin: 32px 0;
    `}
`;

export const TextOnlyContainer = styled.div<LabelProps>`
  ${(props) =>
    props.isTextOnly &&
    css`
      display: none;
    `}
`;
